import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import logo from "../../images/logo2.png";
import { scAxiosAdmin } from '../..';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!email) {
      isValid = false;
      newErrors.email = "*Please enter your email address.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      isValid = false;
      newErrors.email = "*Please enter a valid email address.";
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      console.log("Email:", email);
      return new Promise((resolve, reject) => {
        const req = scAxiosAdmin.post('/forgetpassword', { email, base_url: window.location.origin }, {
          headers: {
            'Accept': 'application/json',
          },
        });
        req.then(res => resolve(res.data))
          .catch(err => reject(err));
        // Simulate a forgot password API call
        toast.success("Password reset link sent to your email.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
    } else {
      toast.error("Please fix the errors and try again.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <div className="account-bg">
      <div className="account-pages my-5 pt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card">
                <div className="card-body">
                  <div className="text-center mt-4">
                    <div className="mb-3">
                      <a href="/">
                        <img src={logo} height={80} alt="logo" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h4 className="font-size-18 text-muted mt-2 text-center">
                      Forgot Password
                    </h4>
                    <p className="text-muted text-center mb-4">
                      Enter your email to reset your password.
                    </p>
                    <form
                      className="form-horizontal"
                      onSubmit={handleSubmit}
                      noValidate
                    >
                      <div className="form-group">
                        <label htmlFor="user_email">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="user_email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter email"
                          required
                          autoComplete="off"
                        />
                        {errors.email && (
                          <span style={{ color: "red" }}>{errors.email}</span>
                        )}
                      </div>
                      <div className="form-group row mt-4">
                        <div className="col-sm-12 text-right">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Reset Password
                          </button>
                        </div>
                      </div>
                      <div className="form-group mb-0 row">
                        <div className="col-12 mt-4 text-center">
                          <Link to="/adminlogin" className="text-muted">
                            <i className="mdi mdi-arrow-left"></i> Back to Login
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <p>© 2024 United Hospital</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/component/admin/UserChangePassword.js